import { useEffect } from "react";
import { useLocation } from "react-router-dom";

// Sends a GA4 page_view on each client-side route change.
export default function Analytics() {
  const { pathname, search } = useLocation();
  useEffect(() => {
    if (typeof window.gtag === "function") {
      window.gtag("event", "page_view", {
        page_path: pathname + search,
        page_location: window.location.href,
        page_title: document.title,
      });
    }
  }, [pathname, search]);
  return null;
}
